import { Foundation } from 'foundation-sites/js/foundation.core';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';

export class NavigationGruppo {
  constructor (target) {
    this.section = target;

    this.mainNavLinks = this.section.querySelectorAll('.desktop .main-nav .nav-link');
    this.subNavBtnClose = this.section.querySelectorAll('.desktop .main-nav [data-close]');
    this.brandNavLinks = this.section.querySelectorAll('.mobile .brand-nav .brand-link-open-subnav');
    this.hamburger = this.section.querySelector('.mobile [data-hamburger]');
    this.hamburgerClose = this.section.querySelector('.mobile [data-hamburger-close]');
    this.hamburgerSubnav = this.section.querySelector('.mobile .hamburger-sub-nav');
    this.secondarySubnavLinks =
      this.section.querySelectorAll('.mobile .main-nav .nav-link, .mobile .brand-nav .nav-link');
    this.secondarySubnavHamburgerClose =
      this.section.querySelectorAll('.mobile .secondary-sub-nav [data-hamburger-close]');
    this.secondarySubnavClose =
      this.section.querySelectorAll('.mobile .secondary-sub-nav [data-secondary-sub-nav-close]');
  }

  init () {
    this.loading(false);
    this.initDropdown();
    this.onMainNavLinkClick();
    this.onSubNavBtnCloseClick();
    this.onBrandNavLinkClick();
    this.onHamburgerClick();
    this.onSecondarySubnavLinksClick();
    this.onSecondarySubnavCloseClick();
  }

  loading(isLoading = true) {
    this.section.classList.toggle('loading', isLoading);
  }

  initDropdown () {
    Foundation.plugin(Dropdown, 'Dropdown');
    const trigger = $('[data-toggle]');
    const target = $('[data-dropdown]');

    const dropdown = new Dropdown(target);

    trigger.on('click', (e) => {
      e.preventDefault();
      dropdown.toggle();
    })
  }

  onMainNavLinkClick () {
    this.mainNavLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const mainNav = link.closest('.main-nav');
        const navItem = link.closest('.nav-item');
        const subNav = navItem.querySelector('.sub-nav');

        if (subNav) {
          e.preventDefault();
          mainNav.querySelectorAll('.nav-item').forEach(item => {
            if (item === navItem) {
              navItem.classList.toggle('is-sub-nav-opened');
            } else {
              item.classList.remove('is-sub-nav-opened')
            }
          });
        }
      });
    })
  }

  onSubNavBtnCloseClick () {
    this.subNavBtnClose.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const mainNav = btn.closest('.main-nav');
        const navItem = btn.closest('.nav-item');
        const subNav = navItem.querySelector('.sub-nav');

        if (subNav) {
          e.preventDefault();
          mainNav.querySelectorAll('.nav-item').forEach(item => {
            if (item === navItem) {
              navItem.classList.toggle('is-sub-nav-opened');
            } else {
              item.classList.remove('is-sub-nav-opened')
            }
          });
        }
      });
    })
  }

  onBrandNavLinkClick () {
    this.brandNavLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const brandNav = link.closest('.brand-nav');
        const navItem = link.closest('.brand-item');
        const subNav = navItem.querySelector('.brand-sub-nav');

        if (subNav) {
          e.preventDefault();
          brandNav.querySelectorAll('.brand-item').forEach(item => {
            if (item === navItem) {
              navItem.classList.toggle('is-sub-nav-opened');
            } else {
              item.classList.remove('is-sub-nav-opened');
            }
          });
        }
      });
    })
  }

  onHamburgerClick () {
    this.hamburger.addEventListener('click', (e) => {
      e.preventDefault();
      this.hamburgerSubnav.classList.add('is-sub-nav-opened');
    });
    this.hamburgerClose.addEventListener('click', (e) => {
      e.preventDefault();
      this.hamburgerSubnav.classList.remove('is-sub-nav-opened');
    });
  }

  onSecondarySubnavLinksClick () {
    this.secondarySubnavLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const navItem = link.closest('.brand-item, .nav-item');
        const subNav = navItem.querySelector('.secondary-sub-nav');

        if (subNav) {
          e.preventDefault();
          navItem.classList.toggle('is-sub-nav-opened');
        }
      });
    })
  }

  onSecondarySubnavCloseClick () {
    this.secondarySubnavHamburgerClose.forEach(btn => {
      btn.addEventListener('click', () => {
        this.hamburgerSubnav.classList.remove('is-sub-nav-opened');

        this.secondarySubnavLinks.forEach((link) => {
          const navItem = link.closest('.nav-item, .brand-item');

          if (navItem) {
            navItem.classList.remove('is-sub-nav-opened')
          }
        })
      })
    })

    this.secondarySubnavClose.forEach(btn => {
      btn.addEventListener('click', () => {
        const navItem = btn.closest('.nav-item, .brand-item');

        if (navItem) {
          navItem.classList.remove('is-sub-nav-opened')
        }
      });
    })
  }
}
